module.exports = __webpack_public_path__ + "static/media/title.c09e720a.svg";